import { useState, useEffect } from 'react'

export type Lang = 'fr' | 'en'

function detectLang(): Lang {
  const stored = localStorage.getItem('rfl-lang') as Lang | null
  if (stored === 'fr' || stored === 'en') return stored
  const nav = navigator.language.toLowerCase()
  return nav.startsWith('fr') ? 'fr' : 'en'
}

export function useLang() {
  const [lang, setLangState] = useState<Lang>(detectLang)

  useEffect(() => {
    document.documentElement.lang = lang
    localStorage.setItem('rfl-lang', lang)
  }, [lang])

  const toggle = () => setLangState(l => (l === 'fr' ? 'en' : 'fr'))
  const setLang = (l: Lang) => setLangState(l)

  return { lang, toggle, setLang }
}
